import { render } from "./AddCharacter.vue?vue&type=template&id=71c69196&scoped=true"
import script from "./AddCharacter.vue?vue&type=script&lang=js"
export * from "./AddCharacter.vue?vue&type=script&lang=js"

import "./AddCharacter.vue?vue&type=style&index=0&id=71c69196&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-71c69196"]])

export default __exports__